import React, {Component} from 'react';
import classes from './DrugDetails.css';
import * as actions from "../../store/actions";
import connect from "react-redux/es/connect/connect";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {PieChart} from 'react-d3-components';
import countries from "../../../assets/country_codes";
import Link from "react-router-dom/es/Link";

class DrugDetails extends Component {

    state = {
        drugId: -1
    };

    async componentDidMount() {
        await this.setState({drugId: this.props.match.params.id});
        this.props.onDrugFetch(this.state.drugId);
        this.props.getStatisticsForActiveSubstance(this.state.drugId);
        this.props.getStatisticsForBrandName(this.state.drugId);
    };

    getActiveSubstance = () => {
        let drug = this.props.drug;
        let activeSubstance = drug.activeSubstance1Processed;
        if (drug.activeSubstance2Processed && drug.activeSubstance2Processed !== '') {
            activeSubstance += ', ' + drug.activeSubstance2Processed
        }
        if (drug.activeSubstance3Processed && drug.activeSubstance3Processed !== '') {
            activeSubstance += ', ' + drug.activeSubstance3Processed
        }
        if (drug.activeSubstance4Processed && drug.activeSubstance4Processed !== '') {
            activeSubstance += ', ' + drug.activeSubstance4Processed
        }
        if (drug.activeSubstance5Processed && drug.activeSubstance5Processed !== '') {
            activeSubstance += ', ' + drug.activeSubstance5Processed
        }
        if (drug.activeSubstance6Processed && drug.activeSubstance6Processed !== '') {
            activeSubstance += ', ' + drug.activeSubstance6Processed
        }
        return activeSubstance;
    };

    getManufacturers = () => {
        let drug = this.props.drug;
        let manufacturers = [drug.manufacturer1Processed];

        if (drug.manufacturer2Processed && drug.manufacturer2Processed !== '') {
            manufacturers.push(drug.manufacturer2Processed);
        }
        if (drug.manufacturer3Processed && drug.manufacturer3Processed !== '') {
            manufacturers.push(drug.manufacturer3Processed);
        }
        if (drug.manufacturer4Processed && drug.manufacturer4Processed !== '') {
            manufacturers.push(drug.manufacturer4Processed);
        }
        if (drug.manufacturer5Processed && drug.manufacturer5Processed !== '') {
            manufacturers.push(drug.manufacturer5Processed);
        }
        return manufacturers.map(manufacturer => {
            return (
                <Link key={manufacturer} to={{
                    pathname: "/companies/details",
                    state: {companyName: manufacturer},
                    search: '?company=' + manufacturer
                }}>
                    {manufacturer}
                </Link>
            )
        })
    };

    getGenericNames = () => {
        let genericNames = "";
        let drug = this.props.drug;
        genericNames = drug.genericName1Processed;

        if (drug.genericName2Processed && drug.genericName2Processed !== '') {
            genericNames += ', ' + drug.genericName2Processed;
        }
        if (drug.genericName3Processed && drug.genericName3Processed !== '') {
            genericNames += ', ' + drug.genericName3Processed;
        }
        if (drug.genericName4Processed && drug.genericName4Processed !== '') {
            genericNames += ', ' + drug.genericName4Processed;
        }
        if (drug.genericName5Processed && drug.genericName5Processed !== '') {
            genericNames += ', ' + drug.genericName5Processed;
        }
        return genericNames;
    };

    getStrengthAndValue = () => {
        let drug = this.props.drug;
        let strengthValue = drug.strengthValue1Processed + " " + drug.strengthUnit1Processed;
        if (drug.strengthValue2Processed && drug.strengthValue2Processed !== '') {
            strengthValue += ", " + drug.strengthValue2Processed + " " + drug.strengthUnit2Processed;
        }
        return strengthValue;
    };

    getPrice = () => {
        let drug = this.props.drug;
        let price = "";
        if (drug.costPerUnitProcessed && drug.costPerUnitProcessed !== '') {
            price = drug.costPerUnitProcessed;
        }
        if (drug.costCurrencyProcessed && drug.costCurrencyProcessed !== '') {
            price += " " + drug.costCurrencyProcessed;
        }
        return price;

    };

    renderPieChart = (data, prop) => {
        let label = '';
        if (prop === 'BN') label = 'Drugs in countries with same or similar brand name';
        if (prop === 'AS') label = 'Drugs in countries with same or similar active substance';
        if (data && data.length === 0) {
            return null;
        }
        const tooltipPie = (x, y) => {
            return countries[x] + ": " + y.toString();
        };
        return (
            <div>{label}
                <PieChart
                    data={data}
                    width={400}
                    height={400}
                    tooltipOffset={{top: 185, left: 150}}
                    tooltipHtml={tooltipPie}
                    tooltipMode={'fixed'}
                    margin={{top: 0, bottom: 0, left: 50, right: 50}}
                />
            </div>
        )
    };

    renderContent = () => {
        if (!this.props.drug || !this.props.count_per_countries_by_active_substance) {
            return <div className={"d-flex align-items-center justify-content-center min-vh-100"}><CircularProgress/>
            </div>
        } else {
            let drug = this.props.drug;
            return (
                <div className='ibox'>
                    <div className='ibox-title bg-success text-light'>
                        <h2 className='m-0 font-weight-bold'>{drug.brandNameProcessed}</h2>
                    </div>
                    <div className='ibox-content'>
                        <div className='row'>
                            <div className='col'>
                                <h4>
                                    <span className='font-weight-bold'>ATC Code: </span>
                                    <span>{drug.atcCode}</span>
                                </h4>
                                <h4><span
                                    className='font-weight-bold'>Active substances: </span>
                                    <span>{this.getActiveSubstance()}</span>
                                </h4>
                                <h4><span
                                    className='font-weight-bold'>Country code: </span>
                                    <span>{drug.countryCode}</span></h4>
                                <h4><span className='font-weight-bold'>Amount: </span>
                                    <span>{drug.amountProcessed}</span>
                                </h4>
                                <h4><span
                                    className='font-weight-bold'>Dosage form: </span>
                                    <span>{drug.dosageFormProcessed}</span>
                                </h4>
                                <h4><span
                                    className='font-weight-bold'>Strength unit and value: </span>
                                    <span>{this.getStrengthAndValue()}</span>
                                </h4>
                            </div>
                            <div className='col'>
                                <h4><span
                                    className='font-weight-bold'>Manufacturer: </span>
                                    <span>{this.getManufacturers()}</span>
                                </h4>
                                <h4><span className='font-weight-bold'>Price: </span>
                                    <span>{this.getPrice()}</span></h4>
                                <h4><span
                                    className='font-weight-bold'>Licence valid from: </span>
                                    <span>{drug.licenceValidFrom}</span>
                                </h4>
                                <h4><span
                                    className='font-weight-bold'>Licence valid until: </span>
                                    <span>{drug.licenceValidUntil}</span>
                                </h4>
                                <h4><span
                                    className='font-weight-bold'>Prescription status: </span>
                                    <span>{drug.prescriptionStatusProcessed}</span>
                                </h4>
                                <h4><span
                                    className='font-weight-bold'>Generic names: </span>
                                    <span>{this.getGenericNames()}</span>
                                </h4>

                            </div>
                        </div>
                        <div className='row mt-4'>
                            <div className='col text-center'>
                                {this.renderPieChart(this.props.count_per_countries_by_active_substance, 'AS')}
                            </div>
                            <div className='col text-center'>
                                {this.renderPieChart(this.props.count_per_countries_by_brand_name, 'BN')}
                            </div>
                        </div>
                    </div>
                    <div className='ibox-footer'>
                        <a className='btn btn-success btn-xl font-weight-bold mr-3' href={'/drugs'}>
                            Back to list
                        </a>
                        <a className='btn btn-outline btn-success btn-xl font-weight-bold' href={drug.url}>
                            Link to drug
                        </a>
                    </div>
                </div>
            )
        }
    };

    render() {
        return (
            <div className={classes.card}>
                {this.renderContent()}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onDrugFetch: (id) => dispatch(actions.getDrug(id)),
        getStatisticsForActiveSubstance: (id) => dispatch(actions.getStatisticsForActiveSubstance(id)),
        getStatisticsForBrandName: (id) => dispatch(actions.getStatisticsForBrandName(id))
    }
};


const mapStateToProps = state => {
    return {
        drug: state.drugs.drug,
        count_per_countries_by_active_substance: state.drugs.count_per_countries_by_active_substance,
        count_per_countries_by_brand_name: state.drugs.count_per_countries_by_brand_name
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrugDetails);
